import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Screen } from 'src/screens'
import { businessOrderEndpoints } from 'src/api'
import { addToOrderIntent, clearOrderIntent } from 'src/state/business-orders'
import { AVAILABLE_ONBOARDING_PACKAGES, OnboardingPackageCode } from '@meniudigital/shared'
import { State } from 'src/state'
import reverseString from 'src/helpers/reverseString'

export default function OnboardingPackagePayment() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const user = useSelector((state: State) => state.users.user)

  const startPayment = async () => {
    const params = new URLSearchParams(window.location.search)
    const u = params.get('u')
    const p = reverseString(params.get('p') || '')

    if (!user) {
      await window.showModal({
        title: 'Autentificare necesară',
        text: `Acest link de plată este pentru contul „${u}". Te rugăm să te autentifici cu acel cont ca să continui.`,
        confirmButtonText: 'Am înțeles',
        isConfirm: true,
      })
      navigate(Screen.Login)
      return
    }

    if (user.username !== u) {
      await window.showModal({
        title: 'Cont diferit',
        text: `Acest link de plată este pentru contul „${u}", dar acum ești autentificat cu alt cont. Te rugăm să te autentifici cu „${u}".`,
        confirmButtonText: 'Am înțeles',
        isConfirm: true,
      })
      navigate(Screen.Home)
      return
    }

    const isValidCode = AVAILABLE_ONBOARDING_PACKAGES.some(x => x.code === p)

    if (!isValidCode) {
      await window.showModal({
        title: 'Link invalid',
        text: 'Acest link de plată nu este valid. Te rugăm să ne contactezi.',
        confirmButtonText: 'Am înțeles',
        isConfirm: true,
      })
      navigate(Screen.Home)
      return
    }

    dispatch(clearOrderIntent())
    dispatch(addToOrderIntent({ onboardingPackageCode: p as OnboardingPackageCode }))

    let mostRecentOrder
    try {
      mostRecentOrder = await businessOrderEndpoints.getMostRecent()
    } catch (e) {
      navigate(Screen.ChooseBillingType, { replace: true })
      return
    }

    const billingInfo = mostRecentOrder?.billingInfo

    if (billingInfo) {
      dispatch(addToOrderIntent({ billingInfo }))
      navigate(Screen.FinalizeOrder, { replace: true })
    } else {
      navigate(Screen.ChooseBillingType, { replace: true })
    }
  }

  useEffect(() => {
    startPayment()
  }, [])

  return null
}
